import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from '@xref/xref-lib';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-department-help-modal',
  templateUrl: './department-help-modal.component.pug',
  styleUrls: ['./department-help-modal.component.scss'],
  standalone: false
})

export class DepartmentHelpModalComponent implements OnInit {

  constructor(
    public modalRef:BsModalRef,
    private permission: PermissionsService
  ) { }

  ngOnInit(): void {
  }

}
